import styled from 'styled-components';
import { px2rem } from '@moim/common';
import { Svg48NoRight, Svg48Empty } from '@moim/icons';

var Container = styled.div.withConfig({
  displayName: "Container",
  componentId: "sc-1laxqsw-0"
})(["padding:", " 0;display:flex;flex-direction:column;align-items:center;justify-content:center;color:", ";"], px2rem(80), function (props) {
  return props.theme.colorV2.colorSet.grey300;
});
var NoRightIcon = styled(Svg48NoRight).attrs({
  size: "l",
  touch: 48
}).withConfig({
  displayName: "NoRightIcon",
  componentId: "sc-1laxqsw-1"
})([""]);
var EmptyIcon = styled(Svg48Empty).attrs({
  size: "l",
  touch: 48
}).withConfig({
  displayName: "EmptyIcon",
  componentId: "sc-1laxqsw-2"
})([""]);

export { Container, EmptyIcon, NoRightIcon };
